export default __webpack_public_path__ + "static/FReg-4x3-S_Sport-e6a6917a28f4d15226c1066786aa93e0.jpg";